// Relay ids are base64 and can contain "/" or "+", so they're encoded in the path.
const programmingPath = (clientId: string) => `/clients/${clientId}/ehr-data/programming`;

export const ehrGoalPath = (clientId: string, goalId: string) =>
  `${programmingPath(clientId)}/${encodeURIComponent(goalId)}`;

export const ehrTargetPath = (clientId: string, goalId: string, targetId: string) =>
  `${ehrGoalPath(clientId, goalId)}/targets/${encodeURIComponent(targetId)}`;

export const ehrUnmatchedSessionDataPath = (clientId: string) => `${programmingPath(clientId)}/unmatched`;
